{
  "submit": "Submit",
  "submitHint": "Select thumbs up or down to submit.",
  "confirmation": "Thank you for your feedback!",
  "error": "Sorry, an error occurred. Please try again later.",
  "tryAgain": "Try again",
  "yes": "Yes",
  "no": "No",
  "like": "Like",
  "dislike": "Dislike",
  "close": "Close",
  "feedback": "Give feedback",
  "turnstileLoading": "Security check in progress...",
  "block": {
    "title": "Did you find what you were looking for?",
    "negativeLabel": "That's unfortunate. What kind of information were you looking for?",
    "positiveLabel": "Great, do you want to give any feedback?",
    "placeholder": "Your comment..."
  },
  "footer": {
    "title": "What do you think about this page?",
    "placeholder": "Your feedback..."
  }
}
